export default __webpack_public_path__ + "static/media/appstore.36a131a9.webp";